import {
  IDashboardActivityPendingAction,
  IDashboardActivityTypeStatus,
  IData,
  TableStatus,
} from '@evencel/models';

export class GetDashboardActivityTypeStatus {
  public static readonly type = '[Dashboard] GetDashboardActivityTypeStatus';
  constructor(
    public center: string,
    public startDate: string,
    public endDate: string
  ) {}
}

export class GetDashboardActivityTypeStatusResponse {
  public static readonly type =
    '[Dashboard] GetDashboardActivityTypeStatusResponse';
  constructor(
    public data: IData<IDashboardActivityTypeStatus>,
    public status: TableStatus
  ) {}
}

export class GetDashboardActivityPendingActions {
  public static readonly type =
    '[Dashboard] GetDashboardActivityPendingActions';
  constructor(
    public center: string,
    public startDate: string,
    public endDate: string
  ) {}
}

export class GetDashboardActivityPendingActionsResponse {
  public static readonly type =
    '[Dashboard] GetDashboardActivityPendingActionsResponse';
  constructor(
    public data: IDashboardActivityPendingAction,
    public status: TableStatus
  ) {}
}
